// Auto-generated file.
// Don't edit/delete it manually!

const ICONS = {
    SALESFORCE: 'salesforce',
    FUNCTION: 'function',
    ADD: 'add',
    STOP: 'stop',
    STOP_CIRCLE: 'Stop-Circle',
    UNDO: 'undo',
    SPARKLES: 'sparkles',
    SERIOUS_ERROR: 'Serious-Error',
    CONFERENCE_BADGE: 'conference-badge',
    X: 'x',
    TWITTER: 'twitter',
    PAUSE: 'Pause',
    PAUSE_CIRCLE: 'Pause-Circle',
    PERSON_O: 'Person-O',
    ADD_ITEM: 'add-item',
    ADD_MANUALLY: 'add-manually',
    ADD_NOTE: 'add-note',
    ADDRESS: 'address',
    ADN: 'adn',
    ALIGN_CENTER: 'align-center',
    ALIGN_JUSTIFY: 'align-justify',
    ALIGN_LEFT: 'align-left',
    ALIGN_RIGHT: 'align-right',
    ALPHA: 'alpha',
    ANDROID: 'android',
    ANGLE_DOUBLE_RIGHT: 'angle-double-right',
    ANGLE_DOWN: 'angle-down',
    ANGLE_LEFT: 'angle-left',
    ANGLE_RIGHT: 'angle-right',
    ANGLE_UP: 'angle-up',
    APPLE: 'apple',
    AREA_CHART: 'area-chart',
    ARROW_CIRCLE_DOWN: 'arrow-circle-down',
    ARROW_CIRCLE_LEFT: 'arrow-circle-left',
    ARROW_CIRCLE_RIGHT: 'arrow-circle-right',
    ARROW_CIRCLE_UP: 'arrow-circle-up',
    ARROW_DOWN: 'arrow-down',
    ARROW_UP: 'arrow-up',
    ARROWS: 'arrows',
    ARROWS_ALT: 'arrows-alt',
    ARROWS_ALT_C: 'arrows-alt-c',
    BAG: 'bag',
    BAN: 'ban',
    BAR_CHART: 'bar-chart',
    BARS: 'bars',
    BELL: 'bell',
    BELL_LIGHT: 'bell-light',
    BINOCULARS: 'binoculars',
    BOLD: 'bold',
    BOOKMARK_DARK: 'bookmark-dark',
    BOOKMARK_LIGHT: 'bookmark-light',
    BOX_AND_WHISKER_CHART: 'box-and-whisker-chart',
    BRACKETS: 'brackets',
    BRAIN: 'brain',
    BUILDING: 'building',
    BUILDING1: 'building1',
    BULLHORN: 'bullhorn',
    CALENDAR: 'calendar',
    CALENDAR_CHECK: 'calendar-check',
    CARD: 'card',
    CARET_RIGHT: 'caret-right',
    CHAIN: 'chain',
    CHART_BARS: 'chart-bars',
    CHECK: 'check',
    CHECK_CIRCLE: 'check-circle',
    CHECK_SQUARE: 'check-square',
    CHECK_SQUARE_DARK: 'check-square-dark',
    CHESS: 'chess',
    CHEVRON_DOWN: 'chevron-down',
    CHEVRON_LEFT: 'chevron-left',
    CHEVRON_RIGHT: 'chevron-right',
    CHEVRON_UP: 'chevron-up',
    CHROME: 'chrome',
    CIRCLE: 'circle',
    CLOCK: 'clock',
    CLONE: 'clone',
    COLLAPSE_ARROW: 'collapse-arrow',
    COMMENT_O: 'comment-o',
    COMMENTING: 'commenting',
    COMMENTING_O: 'commenting-o',
    COMMENTS: 'comments',
    COMPRESS: 'compress',
    COPY: 'copy',
    CREDIT_ANALYSIS: 'credit-analysis',
    CROSS: 'cross',
    CUBES: 'cubes',
    DASHBOARD: 'dashboard',
    DATABASE: 'database',
    DATABASE_PLUS: 'database-plus',
    DELETE_LIST: 'delete-list',
    DESKTOP: 'desktop',
    DESKTOP_PLAY: 'desktop_play',
    DIAGRAM: 'diagram',
    DISCOVER: 'discover',
    DOLLAR: 'dollar',
    DOWNLOAD: 'download',
    EDIT: 'edit',
    ELLIPSIS_H: 'ellipsis-h',
    ENVELOPE: 'envelope',
    ENVELOPE_DARK: 'envelope-dark',
    ENVELOPE_OPEN: 'envelope-open',
    EXCEL_PLUGIN: 'excel-plugin',
    EXCLAMATION: 'exclamation',
    EXPAND: 'expand',
    EXPAND_ARROW: 'expand-arrow',
    EXPANDED_EQUITY_RESEARCH: 'expanded-equity-research',
    EXTERNAL_LINK: 'external-link',
    EYE: 'eye',
    EYE_SLASH: 'eye-slash',
    FACEBOOK: 'facebook',
    FEEDBACK: 'feedback',
    FILE: 'file',
    FILE_CODE_O: 'file-code-o',
    FILE_CSV: 'file-csv',
    FILE_TEXT: 'file-text',
    FILE_TEXT_O: 'file-text-o',
    FILE_TEXT_O_ROTATE: 'file-text-o-rotate',
    FILM: 'film',
    FILTER: 'filter',
    FILTER_FILL: 'filter-fill',
    FLASH: 'flash',
    FLEXIBILITY: 'flexibility',
    FOCUS: 'focus',
    FOLDER: 'folder',
    FOLDER_OPEN_O: 'folder-open-o',
    FONT_A: 'font-a',
    GEARS: 'gears',
    GLOBE: 'globe',
    GRAPH_CHECK: 'graph-check',
    GRAPH_PENCIL: 'graph-pencil',
    GROUP: 'group',
    GROUP_LIST: 'group-list',
    HANDSHAKE: 'handshake',
    HANDSHAKE_O: 'handshake-o',
    HASHTAG: 'hashtag',
    HISTORY: 'history',
    HOURGLASS: 'hourglass',
    ICON_APPLICATIONS: 'icon-applications',
    ICON_COLLAPSE_ARROW: 'icon-collapse-arrow',
    ICON_COMPANY_BUILDING: 'icon-company-building',
    ICON_EXPAND: 'icon-expand',
    ICON_HANDSHAKE: 'icon-handshake',
    ICON_INSTITUTION: 'icon-institution',
    ICON_INVESTORS_FUNDS: 'icon-investors-funds',
    ICON_LIBRARY2_REPORTS: 'icon-library2-reports',
    ICON_MARKET_ANALYSIS_CHART: 'icon-market-analysis-chart',
    ICON_MY_PITCHBOOK: 'icon-my-pitchbook',
    ICON_PEOPLE: 'icon-people',
    ICON_SAFE_DEBT_LENDERS: 'icon-safe-debt-lenders',
    ICON_SCREENER: 'icon-screener',
    ICON_SERVICE_PROVIDER_BRIEFCASE: 'icon-service-provider-briefcase',
    ICON_STOCK_PUBLIC: 'icon-stock-public',
    ICON_WORKFLOW_TOOLS: 'icon-workflow-tools',
    INDENT: 'indent',
    INDICATOR_DOWN: 'indicator-down',
    INDICATOR_UP: 'indicator-up',
    INDUSTRY: 'industry',
    INFO: 'info',
    INSTITUTION: 'institution',
    ITALIC: 'italic',
    LAPTOP: 'laptop',
    LIBRARY: 'library',
    LIGHT_BULB: 'light-bulb',
    LINE_CHART: 'line-chart',
    LINKEDIN: 'linkedin',
    LIST: 'list',
    LIST_ADD: 'list-add',
    LIST_ALT: 'list-alt',
    LIST_OL: 'list-ol',
    LIST_OLD: 'list-old',
    LIST2: 'list2',
    LOCK: 'lock',
    LOG_OUT: 'log-out',
    LONG_ARROW_DOWN: 'long-arrow-down',
    LONG_ARROW_UP: 'long-arrow-up',
    MAIL_FORWARD: 'mail-forward',
    MAP: 'map',
    MAP_MARKER: 'map-marker',
    MAP_PAPER: 'map-paper',
    MAP_PAPER_O: 'map-paper-o',
    MARKET_RELATED_FEATURES: 'market-related-features',
    MERGE: 'merge',
    MESSAGE: 'message',
    MINUS: 'minus',
    MINUS_CIRCLE: 'minus-circle',
    MOBILE_PHONE: 'mobile-phone',
    MONEY_BILL_WAVE: 'money-bill-wave',
    MY_GROUP: 'my-group',
    NEWSPAPER: 'newspaper',
    NEWSPAPER_O: 'newspaper-o',
    NOTE: 'note',
    OUTDENT: 'outdent',
    PAGINATION: 'pagination',
    PAINT_BRUSH: 'paint-brush',
    PAPERCLIP: 'paperclip',
    PB: 'pb',
    PENCIL: 'pencil',
    PEOPLE_ICON: 'people-icon',
    PERSON_ROUNDED: 'person-rounded',
    PHONE: 'phone',
    PIE_CHART2: 'pie-chart2',
    PITCHBOOK_LOGO: 'pitchbook-logo',
    PITCHBOOK_LOGO_V2: 'pitchbook-logo-v2',
    PLAY: 'play',
    PLAY_CIRCLE: 'play-circle',
    PLUGINS: 'plugins',
    PLUS: 'plus',
    PLUS_CIRCLE: 'plus-circle',
    POWER: 'power',
    PRINT: 'print',
    PUBLIC_COMPANIES: 'public-companies',
    QUESTION: 'question',
    QUESTION_CIRCLE: 'question-circle',
    REMOVE: 'remove',
    REPEAT: 'repeat',
    REPLY_ALL: 'reply-all',
    SAVE: 'save',
    SAVED_SEARCH: 'saved-search',
    SCREENER: 'screener',
    SEARCH: 'search',
    SEARCH_C: 'search-c',
    SEARCH2: 'search2',
    SEEDLING: 'seedling',
    SELECT_ALL: 'select-all',
    SELECT_TOP: 'select-top',
    SERVER: 'server',
    SETTINGS: 'settings',
    SHARE_ICON: 'share-icon',
    SHOW_SELECTED: 'show-selected',
    SIDEBAR: 'sidebar',
    SIGNAL: 'signal',
    SIMILARITY: 'similarity',
    SITEMAP: 'sitemap',
    SLIDERS: 'sliders',
    SORT_COLUMNS: 'sort-columns',
    SORT_ICON: 'sort-icon',
    SP_ICON: 'sp-icon',
    STACK_OVERFLOW: 'stack-overflow',
    STICKY_NOTE: 'sticky-note',
    STRIKETHROUGH: 'strikethrough',
    SYNC: 'sync',
    TABLE: 'table',
    TABLE_FOUR: 'table_four',
    TASKS: 'tasks',
    TH: 'th',
    THUMBS_O_DOWN: 'thumbs-o-down',
    THUMBS_O_UP: 'thumbs-o-up',
    TIME: 'time',
    TIMELINE: 'timeline',
    TIMES_CIRCLE: 'times-circle',
    TOGGLE_ON: 'toggle-on',
    TRASH: 'trash',
    TRASH_LIGHT: 'trash-light',
    TREE_MAP: 'tree-map',
    TWITTER1: 'twitter1',
    UNDERLINE: 'underline',
    UNLOCK: 'unlock',
    UPLOAD: 'upload',
    UPLOAD1: 'upload1',
    USER: 'user',
    USER_CIRCLE: 'user-circle',
    USER_ICON: 'user-icon',
    USER_PLUS: 'user-plus',
    USERS: 'users',
    WARNING: 'warning',
    WORKFLOW: 'workflow',
    WRENCH: 'wrench',
    YOUTUBE: 'youtube',
    ID_BADGE: 'id-badge',
    WEB: 'web',
    COLLAPSE_FULL_SCREEN: 'Collapse-full-screen',
    INVESTOR: 'Investor',
    QUOTE: 'Quote',
    ARROW_DOWN_RIGHT: 'arrow-down-right',
    ARROW_UP_RIGHT: 'arrow-up-right',
    AUDIO_FILE: 'audio-file',
    BUBBLE: 'bubble',
    CIRCLE_DOWN: 'circle-down',
    CIRCLE_LEFT: 'circle-left',
    CIRCLE_RIGHT: 'circle-right',
    CIRCLE_UP: 'circle-up',
    CLEAR_FORMATTING: 'clear-formatting',
    COGS: 'cogs',
    CREDIT_ANALYSIS_CHART: 'credit-analysis-chart',
    DIALOG: 'dialog',
    DOCUMENT_READER: 'document-reader',
    FILE_EXCEL: 'file-excel',
    FILE_PDF: 'file-pdf',
    FILE_PICTURE: 'file-picture',
    FILE_WORD: 'file-word',
    FONT: 'font',
    FUND_ANALYSIS_CHART: 'fund-analysis-chart',
    PIE_CHART: 'pie-chart',
    PREVIEW: 'preview',
    PRICE_TAGS: 'price-tags',
    RADIO_CHECKED: 'radio-checked',
    STAR_EMPTY: 'star-empty',
    STAR_FULL: 'star-full',
    STAR_HALF: 'star-half',
    TREE: 'tree',
    TYPOGRAPHY: 'typography',
    BOOK: 'book',
    CHAT: 'chat',
    CLOSE: 'close',
};

export default ICONS;
